import React from 'react';
import { useTranslation } from '../i18n';

function ErrorFallback({ error, onReset }) {
  const { t } = useTranslation();
  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.icon}>!</div>
        <h2 style={styles.title}>{t('error.title')}</h2>
        <p style={styles.message}>
          {error?.message || t('error.generic')}
        </p>
        <button onClick={onReset} style={styles.button}>
          {t('error.refresh')}
        </button>
      </div>
    </div>
  );
}

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('ErrorBoundary caught:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <ErrorFallback
          error={this.state.error}
          onReset={() => {
            this.setState({ hasError: false, error: null });
            window.location.reload();
          }}
        />
      );
    }
    return this.props.children;
  }
}

const styles = {
  container: {
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    minHeight: '60vh', padding: 20,
  },
  card: {
    textAlign: 'center', padding: '40px 32px', background: '#fff',
    borderRadius: 12, boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
    maxWidth: 400, width: '100%',
  },
  icon: {
    width: 56, height: 56, borderRadius: '50%', background: '#fef2f2',
    color: '#dc2626', fontSize: 28, fontWeight: 700, lineHeight: '56px',
    margin: '0 auto 16px', border: '2px solid #fecaca',
  },
  title: { fontSize: 18, fontWeight: 700, color: '#1e293b', margin: '0 0 8px' },
  message: { fontSize: 14, color: '#64748b', margin: '0 0 24px', lineHeight: 1.5 },
  button: {
    padding: '10px 24px', background: '#0c4a6e', color: '#fff',
    border: 'none', borderRadius: 8, fontSize: 14, fontWeight: 600,
    cursor: 'pointer',
  },
};
